import './partners.less'

import {Image, m} from '@codeurs/front'
import React from 'react'
import {ImageType, LinkType} from 'types'
import {style} from 'util/style'

export type PartnersData = Array<PartnerData>
export type PartnerData = {
	link: LinkType
	image: ImageType
}
const styles = style('partners', ['item'])

export const Partners: React.FC<{partners: PartnersData}> = ({partners}) => (
	<div class={styles}>
		{partners.map(partner => (
			<Partner {...partner} />
		))}
	</div>
)

const Partner: React.FC<PartnerData> = ({...partner}) => {
	const Tag = partner.link ? 'a' : 'span'
	if (!partner.image) return null
	return (
		<Tag href={partner.link ? partner.link.url : null} className={styles.item}>
			<Image {...partner.image} />
		</Tag>
	)
}
